import {findIndex} from "lodash"

function loadTree(array, destination) {
  array.forEach(item => {
    fixChildrens(item)
    recChild(item, destination, array);
  });
}

function recChild(item, destination, array) {
  if (!item.parent) {
    destination.push(item);
  } else {
    let parentIndex = findIndex(array, fItem => {
      return fItem.id == item.parent.id
    });
    if (array[parentIndex].children) {
      array[parentIndex].children.push(item);
    } else {
      array[parentIndex].children = [];
      array[parentIndex].children.push(item);
    }
  }
}

function fixChildrens(cat) {
  if (!cat.childrens) return
  cat.children = cat.childrens.map(cat => fixChildrens(cat))
  delete cat.childrens
}

function sortStorages(array, places) {
  array.forEach(goodsItem => {
    if (!goodsItem.storages) {
      goodsItem.storages = [];
      for (let i = 0; i < places.length; i++) {
        let storage = {
          count: 0
        };
        goodsItem.storages.push(storage);
      }
    } else if (goodsItem.storages && (goodsItem.storages.length != places.length)) {
      let remain = places.length - goodsItem.storages.length;
      for (let i = 0; i < remain; i++) {
        let storage = {
          count: 0,
          temp: true,
          storage: null
        };
        goodsItem.storages.push(storage);
      }
    }
  });

  array.forEach(item => {
    let resultArray = [];
    for (let i = 0; i < places.length; i++) {
      let temp = {};
      resultArray.push(temp);
    }
    item.storages.forEach((storage, index) => {
      if (storage.storage) {
        let indOfPlace = findIndex(places, pItem => {
          return pItem.id == storage.storage.id;
        });
        resultArray[indOfPlace] = item.storages[index];
      }
    });
    item.storages = resultArray;
  });
}

export {loadTree, sortStorages}



// WEBPACK FOOTER //
// ./src/modules/productsStorage/services/treeServices.js